/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { WhisperSpinner } from 'react-spinners-kit'
import { useHistory } from 'react-router-dom'
import { ToastsStore } from 'react-toasts'
import { unwrapResult } from '@reduxjs/toolkit'
import { useTranslation } from 'react-i18next'

import Template from 'components/Template'
import Text from 'components/Text'

import useAuthProvider from 'hooks/useAuthProvider'
import useLocalStorage from 'hooks/useLocalStorage'
import useQuery from 'hooks/useQuery'
import useQueryValidation from 'hooks/useQueryValidation'

import PATH from 'utils/path'
import { GRAY, TURQUOISE } from 'assets/colors'
import { verificationThunk } from 'store/@thunks/auth'
import FlexContainer from 'components/FlexContainer'

const Verification = () => {
  const user = useAuthProvider()

  const ls = useLocalStorage()

  const dispatch = useDispatch()

  const history = useHistory()

  const { t } = useTranslation()

  const { code } = useQuery()

  useEffect(() => {
    user.verifyCodeFromEmailOrigin(user.profile.token, () =>
      dispatch(verificationThunk({ code }))
        .then(unwrapResult)
        .then(() => {
          ls.setItem(user.profile.token)
        })
        .catch(({ message }) => {
          ToastsStore.warning(message)
        })
        .finally(() => {
          history.push({
            pathname: PATH.MODELS
          })
        })
    )
  }, [code, dispatch, user.profile])

  useQueryValidation(
    {
      required: ['code']
    },
    exception => {
      exception && history.push(PATH.DASHBOARD)
    }
  )

  return (
    <Template withAnimationType="fadeIn" view>
      {user.loading && (
        <React.Fragment>
          <FlexContainer>
            <WhisperSpinner size={60} frontColor={GRAY} backColor={TURQUOISE} />
          </FlexContainer>
          <br />
          <Text center color="gray" tag="h5">
            {t('LOADING_INDICATOR.verificating')}
          </Text>
        </React.Fragment>
      )}
    </Template>
  )
}

export default Verification
